export type Money = number

export interface ComputeOrderTotalsOptions {
  discount?: Money
  tax?: Money
  tip?: Money
}

export function computeOrderTotals(
  items: Array<{ qty: number; unitPrice: Money }>,
  opts?: ComputeOrderTotalsOptions,
) {
  const subtotal = items.reduce((acc, item) => {
    const quantity = Number.isFinite(item.qty) ? item.qty : 0
    const price = Number.isFinite(item.unitPrice) ? item.unitPrice : 0
    return acc + quantity * price
  }, 0)

  const discount = opts?.discount ?? 0
  const tax = opts?.tax ?? 0
  const tip = opts?.tip ?? 0

  const total = subtotal + tax + tip - discount

  return { subtotal, total }
}
